import { Utilities } from 'library/ts/utilities/Utilities';
import { ISmartTagRuntimeVO } from 'tag/ts/smart_tag/interfaces/ISmartTagRuntimeVO';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Top-URL query param name for the dev/QA override that forces the Mobile Web UI
 * Tag plugin to activate regardless of device capability — needed identically in two places:
 * `TagModel.ts`'s fetch-gate (`processDefaultTagConfig()`) and `MobileWebUI.ts`'s runtime
 * activation gate (`#isMobileWeb()`). Standalone function (mirroring `BrandResolver.ts`'s
 * `getBrand()`) so the Tag-level plugin doesn't need a `TagUtilities` instance, and `TagModel.ts`
 * doesn't need a plugin-side import.
 */
export const FORCE_MOBILE_WEB_UI_QUERY_PARAM = 'forceMobileWebUI';

/**
 * @description Whether `?forceMobileWebUI=1` is present on the top-level URL
 * @param {Utilities} utils - `this.utils` from either call site
 * @param {ISmartTagRuntimeVO} runtimeVO - `this.runtimeVO` from either call site
 * @returns {boolean}
 */
export function isMobileWebUIForced( utils: Utilities, runtimeVO: ISmartTagRuntimeVO ): boolean {
	return utils.URL.getQueryField( FORCE_MOBILE_WEB_UI_QUERY_PARAM, runtimeVO?.top?.url ) === '1';
}